import { Box, Button, Flex, Typography } from '@iheartjane/reefer';

import type { ReviewableProduct } from '../../reviewableProduct';
import { ReviewProductHeader } from '../reviewProductHeader/reviewProductHeader';

import styles from './moreToReviewList.module.css';

export interface MoreToReviewListProps {
  heading: string;
  headingLevel: 'h2' | 'h3';
  onReviewProduct: (product: ReviewableProduct) => void;
  products: ReviewableProduct[];
  testId: string;
}

export function MoreToReviewList({
  heading,
  headingLevel,
  onReviewProduct,
  products,
  testId,
}: MoreToReviewListProps) {
  if (products.length === 0) return null;

  return (
    <Flex flexDirection="column" gap={16} width="100%">
      <Typography
        as={headingLevel}
        color="grays-mid"
        textAlign="center"
        variant="caps-semibold"
      >
        {heading}
      </Typography>
      <ul className={styles['list']} data-testid={`${testId}-more-to-review`}>
        {products.map((product) => (
          <li key={product.id}>
            <Box
              border="grays-light"
              borderRadius="lg"
              data-testid={`${testId}-product-${product.id}`}
              p={16}
            >
              <Flex alignItems="center" gap={16} justifyContent="space-between">
                <ReviewProductHeader
                  brand={product.brand}
                  category={product.category}
                  imageUrl={product.imageUrl}
                  name={product.name}
                  nameMaxLines={2}
                  size="compact"
                  testId={`${testId}-product-${product.id}-header`}
                />
                <Button
                  ariaLabel={`Review ${product.name}`}
                  className={styles['reviewButton']}
                  label="Review"
                  onClick={() => onReviewProduct(product)}
                />
              </Flex>
            </Box>
          </li>
        ))}
      </ul>
    </Flex>
  );
}
